import React from "react";
import BusinessInqueriesButton from "./BusinessInqueriesButton";
export default function Team() {
  return (
    <>
      <div className="anchor" id="team" aria-hidden="true"></div>
      <section className="team" aria-labelledby="team-heading">
        <div className="auto__container">
          <div className="team__inner">
            <div className="team__inner-content">
              <h2 id="team-heading">
                The Brains Behind <span>Proxium</span>
              </h2>
              <p>
                A promising combination of two professional individuals in their
                fields, with over 9 years of aesthetic experience and 25 years
                of biochemistry success, the two responsible for Proxium's
                continued development are the company's core.
              </p>
              <BusinessInqueriesButton />
            </div>
            <div className="team__inner-row">
              <div className="teamItem" role="article">
                <div className="teamItem__image">
                  <img src="/images/team/1.png" alt="Nachshol Cohen - Chief Scientific Officer" />
                </div>
                <div className="teamItem__content">
                  <h4>Nachshol Cohen</h4>
                  <p className="sm">
                    CSO <br /> Chief Scientific Officer
                  </p>
                </div>
              </div>
              <div className="teamItem" role="article">
                <div className="teamItem__image">
                  <img src="/images/team/2.png" alt="Roi Singolda - Chief Medical Officer" />
                </div>
                <div className="teamItem__content">
                  <h4>Roi Singolda</h4>
                  <p className="sm">
                    CMO <br /> Chief Medical Officer
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
